import { FC, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { MenuCommand } from '../../../services/command';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    refresh?: any;
}
export const SCUIMenuApplicationDialog: FC<IProps> = ({ selectedRow, open = false, onClose, refresh }) => {
    const [applicationName, setApplicationName] = useState(selectedRow ? selectedRow?.applicationName : '');

    const [applicationId, setApplicationId] = useState(selectedRow ? selectedRow?.applicationId : '');
    const [applicationDescription, setApplicationDescription] = useState(
        selectedRow ? selectedRow?.applicationDescription : ''
    );
    useEffect(() => {
        setApplicationName(selectedRow?.applicationName === '-' ? ' ' : selectedRow?.applicationName);
        setApplicationId(selectedRow?.applicationId === '-' ? ' ' : selectedRow?.applicationId);
        setApplicationDescription(
            selectedRow?.applicationDescription === '-' ? ' ' : selectedRow?.applicationDescription
        );
    }, [selectedRow]);

    const handleChangeParametre_Key = (event: any) => {
        setApplicationName(event.target.value);
    };
    const handleChangeParametre_Value = (event: any) => {
        setApplicationId(event.target.value);
    };
    const handleChangeParametre_description = (event: any) => {
        setApplicationDescription(event.target.value);
    };

    const { t } = useTranslation();

    const UpdateMenuApplication = async () => {
        let params = {
            id: selectedRow.id,
            applicationName: applicationName,
            applicationDescription: applicationDescription,
            applicationId: applicationId,
        };
        //applicationId?
        MenuCommand.PutMenuApplicationUpdate(params)
            .then((res: any) => {
                if (res.error !== null) {
                    Swal.fire(t('menuManagementAll.errorUpdate'), ' ', 'error');
                } else {
                    Swal.fire(t('general.updated'), ' ', 'success');
                    refresh();
                    onClose();
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    const CreateMenuApplication = async () => {
        let params = {
            applicationName: applicationName,
            applicationDescription: applicationDescription,
            applicationId: applicationId,
        };

        if (
            applicationName &&
            applicationName?.trim().length > 0 &&
            applicationId &&
            applicationId?.trim().length > 0
        ) {
            MenuCommand.PostMenuApplicationAdd(params)
                .then((res: any) => {
                    if (res.error === null) {
                        console.info(res);
                        Swal.fire(t('general.added'), ' ', 'success');
                        refresh();
                        onClose();
                    } else {
                        Swal.fire(t('menuManagementAll.error'), ' ', 'error');
                        onClose();
                    }
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const submitHandler = (event: any) => {
        event.preventDefault();
        CreateMenuApplication();
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('dashboard.menuManagementAll')}</DialogTitle>
            <form onSubmit={submitHandler}>
                <DialogContent>
                    <TextField
                        label={t('menuManagementAll.ApplicationName')}
                        margin="dense"
                        id="applicationName"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.applicationName}
                        onChange={handleChangeParametre_Key}
                    />
                    <TextField
                        label={t('menuManagementAll.ApplicationId')}
                        margin="dense"
                        id="applicationId"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.applicationId}
                        onChange={handleChangeParametre_Value}
                    />
                    <TextField
                        label={t('menuManagementAll.description')}
                        margin="dense"
                        id="applicationDescription"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.applicationDescription}
                        onChange={handleChangeParametre_description}
                    />
                </DialogContent>
                <DialogActions>
                    {selectedRow?.id ? (
                        <Button onClick={UpdateMenuApplication}>{t('general.update')}</Button>
                    ) : (
                        <Button type="submit">{t('general.save')} </Button>
                    )}
                    <Button onClick={onClose}>{t('general.cancel')} </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
